// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// This event fires booking-phone.
function findPhoneError(phoneInput, form) {
  const group = phoneInput.closest("[data-required-phone-group]");
  let errorEl = group ? group.querySelector("[data-required-phone-error]") : null;
  if (!errorEl && form) {
    errorEl = form.querySelector("[data-required-phone-error]");
  }
  if (!errorEl) {
    errorEl = document.createElement("div");
    errorEl.setAttribute("data-required-phone-error", "");
    errorEl.textContent = "Si us plau, introdueixi un telèfon de contacte vàlid per continuar amb la reserva";
    phoneInput.insertAdjacentElement("afterend", errorEl);
  }

  // Estilo de error propio, sin depender de clases del tema
  errorEl.style.color = "#d02b2b";
  errorEl.style.fontSize = "0.875rem";
  errorEl.style.marginTop = "8px";
  errorEl.style.display = "none"; // oculto por defecto

  return errorEl;
}

function showPhoneError(errorEl, phoneInput) {
  errorEl.style.display = "block";
  phoneInput.setAttribute("aria-invalid", "true");
}

function hidePhoneError(errorEl, phoneInput) {
  errorEl.style.display = "none";
  phoneInput.setAttribute("aria-invalid", "false");
}

// Validación al enviar el formulario (fase de captura, antes que el tema)
document.addEventListener("submit", function (evt) {
  const form = evt.target;
  if (!form.matches("[data-product-form]")) return;

  const phoneInput = form.querySelector("[data-required-phone]");
  if (!phoneInput) return;

  const errorEl = findPhoneError(phoneInput, form);
  const digits = phoneInput.value.replace(/\D/g, "");
  const isValid = /^\d{9,15}$/.test(digits);

  if (!isValid) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    showPhoneError(errorEl, phoneInput);
    phoneInput.focus();
  } else {
    hidePhoneError(errorEl, phoneInput);
  }
}, true);

// Limitar a 15 dígitos máximo (sin contar espacios) y solo números y espacios
document.addEventListener("input", function (evt) {
  const el = evt.target;
  if (!el.matches("[data-required-phone]")) return;

  // Quitar todo lo que no sea dígito o espacio
  let cleaned = el.value.replace(/[^\d\s]/g, "");

  // Cortar si supera los 15 dígitos
  const digitsOnly = cleaned.replace(/\D/g, "");
  if (digitsOnly.length > 15) {
    let count = 0;
    let result = "";
    for (const char of cleaned) {
      if (/\d/.test(char)) {
        if (count >= 15) break;
        count++;
      }
      result += char;
    }
    cleaned = result;
  }

  if (cleaned !== el.value) el.value = cleaned;

  // Limpiar el aviso en cuanto el teléfono pase a ser válido
  const form = el.closest("[data-product-form]");
  const errorEl = findPhoneError(el, form);
  const finalDigits = el.value.replace(/\D/g, "");
  if (/^\d{9,15}$/.test(finalDigits)) {
    hidePhoneError(errorEl, el);
  }
});